// 火影同人动漫站 · 站内作品 mock 数据

export type Category = "剧情" | "穿越" | "系统" | "重生" | "战斗";

export interface FanWork {
  id: number;
  title: string;
  category: Category;
  tags: string[];
  chapters: string;
  status: "连载中" | "已完结";
  score: string;
  views: string;
  intro: string;
  author: string;
  updated: string;
  cover: string;
}

export const CATEGORIES: { key: Category; icon: string; desc: string }[] = [
  { key: "剧情", icon: "ri-book-open-line", desc: "紧扣原作脉络的深度剧情节流" },
  { key: "穿越", icon: "ri-send-plane-line", desc: "穿越木叶，改写忍者世界的命运" },
  { key: "系统", icon: "ri-braces-line", desc: "绑定金手指系统，一路开挂崛起" },
  { key: "重生", icon: "ri-refresh-line", desc: "重来一次，弥补遗憾登顶忍界" },
  { key: "战斗", icon: "ri-flashlight-line", desc: "热血压制战，忍术碰撞燃到爆" },
];

export const fanWorks: FanWork[] = [
  {
    id: 1,
    title: "木叶之我的查克拉能复制忍术",
    category: "系统",
    tags: ["系统", "金手指", "热血流"],
    chapters: "第 268 话",
    status: "连载中",
    score: "9.2",
    views: "1280 万",
    intro: "穿越成木叶下忍，意外觉醒复制忍术系统，从此影级忍术信手拈来。",
    author: "千手青禾",
    updated: "今日更新",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20young%20ninja%20hero%20holding%20orange%20chakra%20orb%2C%20konoha%20village%20background%20at%20dusk%2C%20warm%20orange%20and%20amber%20tones%2C%20dynamic%20pose%2C%20dramatic%20lighting%2C%20high%20detail%20manga%20illustration&width=600&height=820&seq=naruto-work-01&orientation=portrait",
  },
  {
    id: 2,
    title: "火影之从第七班开始逆袭",
    category: "剧情",
    tags: ["成长", "羁绊", "原作线"],
    chapters: "第 342 话",
    status: "连载中",
    score: "9.5",
    views: "2030 万",
    intro: "在第七班的日子，从不起眼的小角色开始，一步步成为守护同伴的强大忍者。",
    author: "鸣人家的猫",
    updated: "今日更新",
    cover: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20three%20young%20ninjas%20team%20standing%20together%20facing%20sunset%20with%20leaf%20village%20symbol%20headband%2C%20warm%20golden%20orange%20lighting%2C%20inspiring%20companionship%20mood%2C%20manga%20art&width=600&height=820&seq=naruto-work-02&orientation=portrait",
  },
  {
    id: 3,
    title: "从药师兜开始当火影",
    category: "穿越",
    tags: ["穿越", "权谋", "反套路"],
    chapters: "第 219 话",
    status: "连载中",
    score: "9.0",
    views: "986 万",
    intro: "穿越成幼年药师兜，前世的医学知识加上对剧情的熟知，他将走出不同的道路。",
    author: "猿飞黄昏",
    updated: "昨天更新",
    cover: "https://readdy.ai/api/search-image?query=mysterious%20young%20ninja%20with%20round%20glasses%20and%20medical%20kit%20in%20dim%20konoha%20corridor%2C%20cool%20teal%20and%20amber%20contrast%2C%20intriguing%20atmosphere%2C%20anime%20manga%20illustration%20high%20detail&width=600&height=820&seq=naruto-work-03&orientation=portrait",
  },
  {
    id: 4,
    title: "忍者之巅：火影日常签到",
    category: "系统",
    tags: ["签到", "轻松", "日常"],
    chapters: "第 156 话",
    status: "连载中",
    score: "8.8",
    views: "742 万",
    intro: "每天在火影办公室签到，领取忍术与秘术，顺便把木叶经营成忍界最宜居的地方。",
    author: "木叶老猫",
    updated: "3 天前更新",
    cover: "https://readdy.ai/api/search-image?query=cozy%20chibi%20style%20ninja%20at%20office%20desk%20with%20scrolls%20and%20seals%2C%20cute%20warm%20cream%20and%20orange%20palette%2C%20soft%20comic%20illustration%2C%20relaxed%20daily%20life%20mood&width=600&height=820&seq=naruto-work-04&orientation=portrait",
  },
  {
    id: 5,
    title: "火影之宇智波重生录",
    category: "重生",
    tags: ["重生", "复仇", "写轮眼"],
    chapters: "第 287 话",
    status: "连载中",
    score: "9.3",
    views: "1560 万",
    intro: "重生回灭族之夜前夜，带着未来的记忆，他要改写宇智波一族的悲惨命运。",
    author: "写轮眼的光",
    updated: "今日更新",
    cover: "https://readdy.ai/api/search-image?query=serious%20young%20uchiha%20ninja%20with%20sharingan%20red%20eyes%20and%20katana%2C%20dark%20night%20with%20moon%2C%20crimson%20and%20amber%20accent%20lighting%2C%20epic%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-05&orientation=portrait",
  },
  {
    id: 6,
    title: "鸣人的平行忍界",
    category: "穿越",
    tags: ["平行世界", "冒险", "热血"],
    chapters: "第 203 话",
    status: "已完结",
    score: "9.1",
    views: "1180 万",
    intro: "鸣人意外穿梭到另一个忍界，那里没有尾兽，却有更强的敌人与更多的伙伴。",
    author: "螺旋丸的执着",
    updated: "5 天前更新",
    cover: "https://readdy.ai/api/search-image?query=energetic%20blonde%20ninja%20with%20whisker%20marks%20spinning%20chakra%20sphere%20in%20alternate%20world%2C%20dramatic%20wind%20and%20leaves%2C%20vibrant%20orange%20sky%2C%20high%20energy%20manga%20art&width=600&height=820&seq=naruto-work-06&orientation=portrait",
  },
  {
    id: 7,
    title: "忍术不够？我用科学开挂",
    category: "系统",
    tags: ["科技", "脑洞", "轻松"],
    chapters: "第 178 话",
    status: "连载中",
    score: "8.6",
    views: "654 万",
    intro: "穿越成忍界的天才科学家，用现代物理学和忍术结合，把木叶武装到牙齿。",
    author: "物理系上忍",
    updated: "2 天前更新",
    cover: "https://readdy.ai/api/search-image?query=young%20ninja%20scientist%20with%20goggles%20and%20tech%20gadgets%20in%20futuristic%20workshop%2C%20cyan%20and%20warm%20amber%20contrast%2C%20clever%20inventive%20mood%2C%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-07&orientation=portrait",
  },
  {
    id: 8,
    title: "火影之最强体术流",
    category: "战斗",
    tags: ["体术", "燃向", "无印"],
    chapters: "第 241 话",
    status: "连载中",
    score: "9.0",
    views: "913 万",
    intro: "不靠忍术不靠写轮眼，主角靠一双手与拳头，硬生生在忍界打出赫赫威名。",
    author: "八门遁甲的传人",
    updated: "今日更新",
    cover: "https://readdy.ai/api/search-image?query=muscular%20ninja%20in%20taijutsu%20fighting%20stance%20with%20blue-green%20chakra%20aura%2C%20dynamic%20impact%20lines%2C%20hot%20battle%20mood%2C%20warm%20orange%20background%2C%20manga%20illustration&width=600&height=820&seq=naruto-work-08&orientation=portrait",
  },
  {
    id: 9,
    title: "重生之我是自来也",
    category: "重生",
    tags: ["师徒", "热血", "遗憾弥补"],
    chapters: "第 256 话",
    status: "连载中",
    score: "9.4",
    views: "1340 万",
    intro: "重生为年轻时的自来也，这一次，他要保住妙木山的传承，更要护住心爱的弟子。",
    author: "蛤蟆仙人的梦",
    updated: "昨天更新",
    cover: "https://readdy.ai/api/search-image?query=white%20haired%20toad%20sage%20ninja%20with%20long%20hair%20standing%20by%20giant%20toad%2C%20misty%20mountain%20temple%2C%20serene%20yet%20epic%20mood%2C%20warm%20and%20earthy%20tones%2C%20manga%20illustration&width=600&height=820&seq=naruto-work-09&orientation=portrait",
  },
  {
    id: 10,
    title: "影分身打工的我成了幕后大佬",
    category: "系统",
    tags: ["爽文", "脑洞", "经营"],
    chapters: "第 132 话",
    status: "连载中",
    score: "8.5",
    views: "521 万",
    intro: "别人用影分身战斗，他用影分身打工经商，意外卷入忍界暗流，成了幕后大鳄。",
    author: "金库里的鹿",
    updated: "4 天前更新",
    cover: "https://readdy.ai/api/search-image?query=smiling%20ninja%20with%20shadow%20clone%20silhouettes%20handling%20gold%20coins%20and%20documents%2C%20playful%20clever%20mood%2C%20warm%20amber%20and%20cream%20palette%2C%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-10&orientation=portrait",
  },
  {
    id: 11,
    title: "木叶村的那些年",
    category: "剧情",
    tags: ["群像", "温情", "日常"],
    chapters: "第 310 话",
    status: "已完结",
    score: "9.6",
    views: "2480 万",
    intro: "不追求最强，只记录木叶村平凡而温暖的日常，写尽忍者们的欢笑与泪水。",
    author: "奈良的风",
    updated: "6 天前更新",
    cover: "https://readdy.ai/api/search-image?query=group%20of%20friendly%20ninjas%20gathering%20in%20cozy%20konoha%20market%20street%20at%20warm%20sunset%2C%20heartwarming%20community%20mood%2C%20soft%20warm%20tones%2C%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-11&orientation=portrait",
  },
  {
    id: 12,
    title: "火影之写轮眼的羁绊",
    category: "战斗",
    tags: ["宿命", "兄弟", "燃向"],
    chapters: "第 233 话",
    status: "连载中",
    score: "8.9",
    views: "867 万",
    intro: "围绕写轮眼的宿命与兄弟情，一场又一场惊心动魄的忍界大战就此展开。",
    author: "月读的化身",
    updated: "3 天前更新",
    cover: "https://readdy.ai/api/search-image?query=two%20rival%20uchiha%20ninjas%20with%20sharingan%20clashing%20in%20midnight%20forest%2C%20crimson%20moon%20and%20fire%2C%20intense%20duel%20mood%2C%20high%20contrast%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-12&orientation=portrait",
  },
  {
    id: 13,
    title: "穿越成晓组织的我选择摆烂",
    category: "穿越",
    tags: ["反套路", "搞笑", "轻松"],
    chapters: "第 167 话",
    status: "连载中",
    score: "8.7",
    views: "698 万",
    intro: "穿越成晓组织成员，却只想摸鱼摆烂，结果越摆烂越被所有人当成深不可测。",
    author: "红云里的咸鱼",
    updated: "2 天前更新",
    cover: "https://readdy.ai/api/search-image?query=relaxed%20ninja%20in%20red%20cloud%20black%20cloak%20lying%20casually%20on%20rooftop%20at%20dusk%2C%20humorous%20laid%20back%20mood%2C%20warm%20red%20and%20amber%20tones%2C%20comic%20anime%20illustration&width=600&height=820&seq=naruto-work-13&orientation=portrait",
  },
  {
    id: 14,
    title: "火影之忍界快递",
    category: "剧情",
    tags: ["日常", "经营", "温情"],
    chapters: "第 145 话",
    status: "连载中",
    score: "8.4",
    views: "489 万",
    intro: "用影分身开起忍界快递，配送着封印卷轴、尾兽查克拉，也配送着每个人的心愿。",
    author: "瞬身的风",
    updated: "1 天前更新",
    cover: "https://readdy.ai/api/search-image?query=cheerful%20ninja%20courier%20carrying%20scroll%20parcel%20through%20konoha%20rooftops%2C%20energetic%20playful%20mood%2C%20warm%20orange%20and%20cream%20palette%2C%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-14&orientation=portrait",
  },
  {
    id: 15,
    title: "轮回眼之影",
    category: "战斗",
    tags: ["瞳术", "史诗", "燃向"],
    chapters: "第 201 话",
    status: "连载中",
    score: "9.1",
    views: "1020 万",
    intro: "六道之力觉醒，主角背负轮回之眼踏上登临忍界巅峰的史诗之路。",
    author: "六道轮回者",
    updated: "今日更新",
    cover: "https://readdy.ai/api/search-image?query=powerful%20ninja%20with%20purple%20rinnegan%20rings%20and%20chakra%20rods%2C%20stormy%20sky%20above%20battlefield%2C%20epic%20majestic%20mood%2C%20dramatic%20warm%20and%20violet%20contrast%2C%20manga%20illustration&width=600&height=820&seq=naruto-work-15&orientation=portrait",
  },
  {
    id: 16,
    title: "火影之沙隐的崛起",
    category: "重生",
    tags: ["崛起", "权谋", "守护"],
    chapters: "第 189 话",
    status: "已完结",
    score: "8.8",
    views: "736 万",
    intro: "重生为沙隐村少年，带领风之国在五大国夹缝中强势崛起。",
    author: "风沙行者",
    updated: "7 天前更新",
    cover: "https://readdy.ai/api/search-image?query=determined%20sand%20village%20ninja%20standing%20in%20desert%20with%20wind%20and%20sand%20swirling%2C%20sun%20glare%2C%20warm%20golden%20amber%20tones%2C%20ambitious%20mood%2C%20anime%20manga%20illustration&width=600&height=820&seq=naruto-work-16&orientation=portrait",
  },
];

// 追更榜单数据
export const trendingList = [
  { rank: 1, title: "火影之从第七班开始逆袭", category: "剧情", hot: "🔥 98.2", delta: "↑ 2" },
  { rank: 2, title: "重生之我是自来也", category: "重生", hot: "🔥 97.5", delta: "↑ 1" },
  { rank: 3, title: "木叶之我的查克拉能复制忍术", category: "系统", hot: "🔥 96.8", delta: "持平" },
  { rank: 4, title: "火影之宇智波重生录", category: "重生", hot: "🔥 95.9", delta: "↑ 3" },
  { rank: 5, title: "木叶村的那些年", category: "剧情", hot: "🔥 94.7", delta: "持平" },
];

// 常见问题
export const faqs = [
  {
    q: "什么是火影同人动漫？",
    a: "火影同人动漫是指由粉丝基于《火影忍者》世界观二次创作的动画、漫画与小说作品。它们保留了原作的角色、忍者体系与木叶村设定，但剧情走向更加自由，常加入穿越、系统、重生等脑洞设定，带来与原作不同的热血体验。",
  },
  {
    q: "站内作品多久更新一次？",
    a: "热门连载作品基本保持每日或隔日更新，我们会在作品卡片与追更榜单中标注最近更新时间。你还可以收藏作品、订阅追更提醒，更新后第一时间收到通知，追更不迷路。",
  },
  {
    q: "穿越、系统、重生这些分类有什么区别？",
    a: "穿越类：主角从现代或异时空进入火影世界；系统类：主角绑定金手指系统辅助成长；重生类：主角带着记忆重新经历人生、弥补遗憾；战斗类：侧重忍术对决与燃向剧情；剧情类：围绕原作脉络展开的深度故事。按兴趣选择即可。",
  },
  {
    q: "需要付费才能观看吗？",
    a: "站内大部分火影同人作品均可免费在线阅读，部分精品长篇连载设有会员抢先看与免广告权益。新用户注册即可领取限时免费阅读券，畅读热门作品。",
  },
  {
    q: "如何提交自己的同人创作？",
    a: "欢迎创作者投稿！你可以在联系方式表单中留下作品简介与样章，或通过站内投稿入口提交。审核通过的作品将有机会登上推荐位与追更榜单，并获得流量扶持。",
  },
  {
    q: "可以收藏作品并同步阅读进度吗？",
    a: "注册登录后即可收藏作品、标记阅读进度，并同步追更列表。无论切换手机还是电脑，阅读记录都会自动同步，随时随地接着看。",
  },
];

// 用户口碑
export const testimonials = [
  {
    name: "木叶后勤部部长",
    avatar: "N",
    text: "在这里追《重生之我是自来也》已经大半年了，更新稳定、剧情扎实，是目前最对我胃口的火影同人站。",
    role: "追更 3 年 · 收藏 42 部",
  },
  {
    name: "写轮眼收藏家",
    avatar: "U",
    text: "分类做得特别细，穿越、系统、战斗一目了然，找同类作品再也不用翻半天了。评论区氛围也很好。",
    role: "追更 2 年 · 收藏 27 部",
  },
  {
    name: "蛤蟆仙人门下",
    avatar: "S",
    text: "最打动我的是站内对创作者的扶持，我投的稿子被选上推荐位，播放量一下子上来了，很感谢这个平台。",
    role: "创作者 · 投稿 5 部",
  },
];